import { useMutation } from '@tanstack/react-query';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: MJS workaround to allow in JS file
import { service } from '../client.mjs';
import { Affiliate, ApiResponse } from '../types';
import { dataOrError } from '../utils/dataOrError';

export interface AffiliateLookupPayload {
  agriaId?: string;
  email?: string;
  postcode?: string;
}

const getCustomAffiliateLookup = async ({
  agriaId,
  email,
  postcode,
}: AffiliateLookupPayload) => {
  const { data } = await service.get<ApiResponse<Affiliate>>(
    '/affiliate/look-up',
    {
      params: {
        AgriaId: agriaId ?? '',
        Email: email ?? '',
        Postcode: postcode ?? '',
      },
    },
  );
  return dataOrError<Affiliate>(data);
};

export function useCustomAffiliateLookup() {
  return useMutation({
    mutationFn: getCustomAffiliateLookup,
  });
}
